/* eslint-disable default-case */
import React, {useState} from "react";
import {FmlxIcon, FmlxModal, FmlxPopover} from "fmlx-common-ui";
import {ACTIVE_TAB, ManageQuestionOperation} from "../../../const/dataEnum";
import {FMLX_BUTTON, FMLX_COMPONENT, FMLX_MODAL} from "../../../const/FmlxComponentEnum";
// import ClickAwayListener from "@mui/base/ClickAwayListener";
import {ClickAwayListener} from "@mui/material";
import {ConsoleLog} from "../../../lib/ConsoleHelper";
import {useManageQuestionContext} from "../../../lib/contexLib";

const NavItem = (props) => {
  const {tab, handleTabClick, handleRename, addTab, deleteTab} = props;
  const {category, categoryOrder, active} = tab;

  const {
    renameTabId,
    setRenameTabId
  } = useManageQuestionContext();
  // const [dropdownOpen, setDropdownOpen] = useState(false);

  const [tabName, setTabName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true)
  }
  const closeModal = () => {
    setIsModalOpen(false)
  }

  const handleInputClickAway = (tabId) => {
    setRenameTabId(null);
    if (tabName) handleRename(tabId, tabName);
  };

  const handleDropdownClick = (operation) => {
    switch (operation) {
      case ManageQuestionOperation.RENAME:
        setRenameTabId(tab.id);
        break;
      case ManageQuestionOperation.DUPLICATE:
        addTab(tab);
        break;
      case ManageQuestionOperation.HIDE:
        ConsoleLog("hide clicked");
        break;
      case ManageQuestionOperation.DELETE:
        openModal();
        break;
    }
    // setDropdownOpen(false);
    setAnchorEl(null);
  };

  const onPopoverCloseHandler = () => {
    setAnchorEl(null);
  }

  const onIconClickHandler = (e) => {
    setAnchorEl(e.currentTarget);
  }

  const onDeleteClickHandler = async () => {
    await deleteTab(tab.categoryOrder, tab.id);
    closeModal();
  }

  return (
    <>
      <div style={{position: "relative"}}>
        <div className={active ? "tab_item active" : "tab_item"}>
          {renameTabId !== null && tab.id === renameTabId ? (
            <ClickAwayListener onClickAway={() => handleInputClickAway(tab.id)}>
              <input autoFocus type="text" className="rename_input" onChange={(e) => setTabName(e.target.value)}/>
            </ClickAwayListener>
          ) : (
            <div onClick={() => handleTabClick(categoryOrder)}>{category}</div>
          )}
          {category !== ACTIVE_TAB.GENERAL && (
            <div onClick={onIconClickHandler}>
              {active ? (
                <FmlxIcon name={"ChevronDown"} size={FMLX_COMPONENT.SIZE.S} customColor={"#006AF5"}/>
              ) : (
                <FmlxIcon name={"ChevronDown"} size={FMLX_COMPONENT.SIZE.S}/>
              )}
            </div>
          )}
        </div>
      </div>
      <FmlxPopover
        id='fmlxpopover-managequestion-tab'
        isOverlay={false}
        anchorEl={anchorEl}
        onClose={onPopoverCloseHandler}
        transformOrigin={{
          horizonal: 'center',
          vertical: 'top'
        }}
        anchorOrigin={{
          horizonal: 'center',
          vertical: 'bottom'
        }}
      >
        <ul className="managequestion-popoverlist">
          <li className="managequestion-popoverlist-item" onClick={() => handleDropdownClick("rename")}>
            Rename
          </li>
          <li className="managequestion-popoverlist-item" onClick={() => handleDropdownClick("delete")}>
            Delete
          </li>
        </ul>
      </FmlxPopover>
      <FmlxModal
        open={isModalOpen}
        title="Delete Category"
        size={FMLX_MODAL.SIZE.MD}
        onCloseClick={() => {
          setIsModalOpen(false)
        }}
        primaryButton={{
          show: true,
          label: 'Delete',
          type: FMLX_BUTTON.TYPE.DANGER,
          variant: FMLX_BUTTON.VARIANT.CONTAIN,
          onClick: onDeleteClickHandler
        }}
        secondaryButton={{
          show: false,
        }}
        tertiaryButton={{
          show: false,
        }}
      >
        <div className="mb-16px">
          Do you want to delete <strong>{tab.category}</strong> category?
        </div>
      </FmlxModal>
    </>
  );
};

export default NavItem;
